module.exports = __webpack_public_path__ + "img/15.ee145300.jpg";